import { render } from "./_read-more.vue?vue&type=template&id=54aed3c0&scoped=true"
import script from "./_read-more.vue?vue&type=script&lang=js"
export * from "./_read-more.vue?vue&type=script&lang=js"

import "./_read-more.vue?vue&type=style&index=0&id=54aed3c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54aed3c0"]])

export default __exports__